export default "__VITE_ASSET__shbGZErQ__"